<template>
  <v-alert
    title="Error"
    variant="outlined"
    type="warning"
    prominent
    border="top"
  >
    No matching path found
  </v-alert>
</template>

<script>

export default {
  name: "NotFound",

};
</script>

<style scoped>


</style>
